// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2KlI5","rootMobile":"styles_rootMobile__3sUpK"};